import { ButtonBase, Card, CardContent, CardMedia } from '@mui/material';
import 'app/agriculture/components/ImageRadioButton/ImageRadioButton.scss';
import { useCallback } from 'react';
import classNames from 'classnames';

interface ImageRadioButtonsProps {
    label: string;
    onToggle?: (isToggled: boolean) => void;
    toggled: boolean;
    image: string;
}

export function ImageRadioButton(props: ImageRadioButtonsProps) {
    const { image, onToggle, toggled, label } = props;

    const handleClick = useCallback(() => {
        if (onToggle) {
            onToggle(!toggled);
        }
    }, []);

    return (
        <ButtonBase
            onClick={handleClick}
            disableRipple
            className="ImageRadioButton"
            data-testid="ImageRadioButton"
        >
            <Card
                className={classNames('ImageRadioButton__card', { 'is-toggled': toggled })}
                data-testid="ImageRadioButtonCard"
            >
                <CardMedia
                    className="ImageRadioButton__card-media"
                    image={image}
                    title={label}
                    data-testid="ImageRadioButtonImage"
                />
                <CardContent className="ImageRadioButton__card-content">
                    <h6 data-testid="ImageRadioButtonLabel">{label}</h6>
                </CardContent>
            </Card>
        </ButtonBase>
    );
}
